/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';

import template from './structure-page.component.html';

@Component({
  standalone: false,
  selector: 'adn-structure-page',
  template
})
export class StructurePageComponent {
  readonly generalDiagramData = {
    entities: [
      {id: 'network', label: 'Network', requirements: [], x: 350, y: 25, color: '#4a90e2'},
      {id: 'advertising', label: 'Advertising', requirements: ['Advertiser', 'Order', 'Line Item', 'Creative'], x: 50, y: 135, color: '#50c878'},
      {id: 'publishing', label: 'Publishing', requirements: ['Publisher', 'Site', 'Ad Unit', 'Ruleset', 'Blocklist', 'Site Group'], x: 250, y: 155, color: '#ff6b6b'},
      {id: 'user', label: 'User / Team', requirements: ['User', 'Team', 'Role', 'Permission'], x: 450, y: 135, color: '#ffa500'},
      {id: 'misc', label: 'Miscellaneous', requirements: ['Election', 'Marketplace Product', 'Layout', 'Layout Include'], x: 650, y: 135, color: '#999'}
    ],
    connections: [
      {from: 'network', to: 'advertising', label: ''},
      {from: 'network', to: 'publishing', label: ''},
      {from: 'network', to: 'user', label: ''},
      {from: 'network', to: 'misc', label: ''}
    ],
    width: 900,
    height: 400
  };

  readonly entityDiagramData = {
    entities: [
      {id: 'advertiser', label: 'Advertiser', requirements: ['Team'], x: 50, y: 50, color: '#4a90e2'},
      {id: 'order', label: 'Order', requirements: ['Team'], x: 250, y: 30, color: '#50c878'},
      {id: 'line-item', label: 'Line Item', requirements: ['M. Product (optional)', 'Election (optional)'], x: 450, y: 50, color: '#ff6b6b'},
      {id: 'creative', label: 'Creative', requirements: ['Layout'], x: 650, y: 50, color: '#ffa500'}
    ],
    connections: [
      {from: 'advertiser', to: 'order', label: 'required by'},
      {from: 'order', to: 'line-item', label: 'required by'},
      {from: 'line-item', to: 'creative', label: 'required by'}
    ],
    width: 900,
    height: 200
  };

  readonly publishingDiagramData = {
    entities: [
      {id: 'publisher', label: 'Publisher', requirements: ['Team'], x: 50, y: 50, color: '#4a90e2'},
      {id: 'site', label: 'Site', requirements: ['Team'], x: 250, y: 30, color: '#50c878'},
      {id: 'adunit', label: 'Ad Unit', requirements: [], x: 450, y: 50, color: '#ff6b6b'},
      {id: 'ruleset', label: 'Ruleset', requirements: [], x: 70, y: 250, color: '#999'},
      {id: 'sitegroup', label: 'Site Group', requirements: [], x: 270, y: 250, color: '#999'},
      {id: 'blocklist', label: 'Blocklist', requirements: [], x: 470, y: 250, color: '#999'},
    ],
    connections: [
      {from: 'publisher', to: 'site', label: 'required by'},
      {from: 'site', to: 'adunit', label: 'required by'},
      {from: 'publisher', to: 'ruleset', label: ''},
      {from: 'publisher', to: 'blocklist', label: ''},
      {from: 'site', to: 'ruleset', label: ''},
      {from: 'site', to: 'sitegroup', label: ''},
      {from: 'site', to: 'blocklist', label: ''},
      {from: 'adunit', to: 'ruleset', label: ''},
      {from: 'adunit', to: 'blocklist', label: ''},
    ],
    width: 900,
    height: 320
  };

  readonly teamDiagramData = {
    entities: [
      {id: 'user', label: 'User', requirements: [], x: 50, y: 50, color: '#4a90e2'},
      {id: 'team', label: 'Team', requirements: [], x: 250, y: 50, color: '#50c878'},
      {id: 'role', label: 'Role', requirements: [], x: 450, y: 50, color: '#ff6b6b'},
      {id: 'permission', label: 'Permission', requirements: [], x: 650, y: 50, color: '#ffa500'}
    ],
    connections: [
      {from: 'user', to: 'team', label: 'can be part of one or more'},
      {from: 'user', to: 'role', label: 'has one team role per team'},
      {from: 'user', to: 'role', label: 'has one network role per network'},
      {from: 'role', to: 'permission', label: 'usually has one or more, can have none'}
    ],
    width: 900,
    height:400
  };

  readonly miscDiagramData = {
    entities: [
      {id: 'mp', label: 'M. Product', requirements: ['Team'], x: 350, y: 30, color: '#4a90e2'},
      {id: 'layout', label: 'Layout', requirements: [], x: 50, y: 125, color: '#ff6b6b'},
      {id: 'li', label: 'Layout Include', requirements: [], x: 350, y: 125, color: '#ffa500'},
      {id: 'election', label: 'Election', requirements: [], x: 650, y: 30, color: '#999'}
    ],
    connections: [
      {from: 'mp', to: 'layout', label: 'uses one or more'},
      {from: 'layout', to: 'li', label: 'can use one or more'},
    ],
    width: 900,
    height: 200
  };
}
